
/**
 * Translates payment details sent to stripe into those that math our Order or PaymentProfile object.
 * Basically just splits "name" into "first_name" and "last_name".  "Kim Jong Un" becomes {first_name: "Kim Jong", last_name: "Un"}
 *
 * @param payment_method
 * @param name
 * @param paymentDetails
 * @returns {{payment_method: *, first_name: string, last_name: *}}
 */
export default (payment_method, {name}) => {
  const nameSplit = name ? name.split(/\s+/).filter(x=>x) : [];
  const [last_name] = nameSplit.slice(-1);
  const first_name = nameSplit.slice(0, -1).join(' ');

  return {
    payment_method,
    first_name,
    last_name
  }
};
